import React, { useEffect, useRef, useState } from 'react';
import '../styles/Score.css';

const Score = ({ title, value }) => {
  const [animation, setAnimation] = useState(false);
  const prevValueRef = useRef(value);

  useEffect(() => {
    if (prevValueRef.current < value) {
      setAnimation(true);
      const timer = setTimeout(() => setAnimation(false), 300);
      return () => clearTimeout(timer);
    }
    prevValueRef.current = value;
  }, [value]);

  return (
    <div className="score-container">
      <div className="score-title">{title}</div>
      <div className="score-value">{value}</div>
      {animation && <div className="score-addition">+{value - prevValueRef.current}</div>}
    </div>
  );
};

export default Score;